import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthenticationService } from '@shared/services/auth/authentication.service';
import { AuthActions, selectAuthInfo } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ThkeeCommonModule } from 'thkee-common';

@Component({
  selector: 'app-admin-header',
  standalone: true,
  imports: [ThkeeCommonModule, AngularSvgIconModule, AsyncPipe, NgIf],
  templateUrl: './admin-header.component.html',
  styleUrl: './admin-header.component.scss',
})
export class AdminHeaderComponent implements OnInit {
  heading: any;
  isSidebar: boolean = false;

  isAuth$ = this.authService.sessionExist();
  userAuthInfo$ = this.store.select(selectAuthInfo);

  constructor(private store: Store, private router: Router, private authService: AuthenticationService) {}

  ngOnInit(): void {}

  logout() {
    this.store.dispatch(AuthActions.logout());
  }
}
